import React from 'react';
import { MDXRenderer } from 'gatsby-plugin-mdx';

import CustomMDXProvider from './CustomMDXProvider';

const CustomMDXRenderer = ({ children }) => {
	return (
		<CustomMDXProvider>
			<MDXRenderer>{children}</MDXRenderer>
		</CustomMDXProvider>
	);
};

export default CustomMDXRenderer;
